import safelyIncrement from '../../helpers/safelyIncrement';

export default (state, action) => {
  const { containerCount, itemCount } = state;
  const { designId, originalId, copyId } = action.payload;

  const updatedContCount = {
    ...containerCount,
    [designId]: safelyIncrement(containerCount[designId]),
  };

  const prevCount = itemCount[originalId];
  const updatedItemCount = {
    ...itemCount,
    [copyId]: prevCount,
  };

  return {
    ...state,
    containerCount: updatedContCount,
    itemCount: updatedItemCount,
  };
};
